import { css } from "styled-components";

export const BUTTON_APPEARANCES = ["primary", "outline", "neutral"] as const;
export const BUTTON_SIZES = ["default", "compact"] as const;

export type ButtonAppearance = (typeof BUTTON_APPEARANCES)[number];
export type ButtonSize = (typeof BUTTON_SIZES)[number];

const sharedDisabled = css`
  &:disabled {
    opacity: 0.48;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const BUTTON_APPEARANCE_STYLES: Record<
  ButtonAppearance,
  ReturnType<typeof css>
> = {
  primary: css`
    height: 32px;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    background-color: #01ab7d;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;

    &:hover:not(:disabled) {
      background-color: #01906a;
    }

    ${sharedDisabled}
  `,
  outline: css`
    border: 1px solid #01ab7d;
    background-color: transparent;
    color: #01ab7d;
    font-weight: 500;
    line-height: 1.4;

    &:hover:not(:disabled) {
      color: #01906a;
      background-color: #f0faf7;
      border-color: #01906a;
    }

    ${sharedDisabled}
  `,
  neutral: css`
    height: 32px;
    padding: 8px 16px;
    border: 1px solid #ceced2;
    border-radius: 5px;
    background-color: transparent;
    color: #131313;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;

    &:hover:not(:disabled) {
      background-color: #f4f4f6;
    }

    ${sharedDisabled}
  `,
};

export const BUTTON_SIZE_STYLES: Record<
  ButtonAppearance,
  Partial<Record<ButtonSize, ReturnType<typeof css>>>
> = {
  outline: {
    default: css`
      padding: 6px 16px;
      border-radius: 5px;
      font-size: 14px;
      min-height: auto;
    `,
    compact: css`
      padding: 7px 24px;
      border-radius: 5px;
      font-size: 13px;
      min-height: 32px;
      min-width: 126px;
      background-color: #fafbff;

      &:hover:not(:disabled) {
        background-color: #fafbff;
        color: #01ab7d;
        border-color: #01ab7d;
      }
    `,
  },
  primary: {},
  neutral: {},
};
